import React, { useEffect, useState } from "react";
import { getContentTranslations, emptyContentTranslations } from "../../i18n/contentTranslationApi";
import { LoadingSpinner } from "../common/Loader";
import "./LocalizedContentFields.css";

const languages = [
  { code: "hi", label: "हिन्दी" },
  { code: "kn", label: "ಕನ್ನಡ" },
];

export default function LocalizedContentFields({ entityType, entityId, fields, value, onChange }) {
  const [activeLanguage, setActiveLanguage] = useState("hi");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let active = true;
    if (!entityId) {
      onChange(emptyContentTranslations());
      return () => { active = false; };
    }
    setLoading(true);
    getContentTranslations(entityType, entityId)
      .then((translations) => active && onChange(translations))
      .catch(() => active && onChange(emptyContentTranslations()))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [entityId, entityType, onChange]);

  const updateField = (field, fieldValue) => {
    onChange({
      ...emptyContentTranslations(),
      ...value,
      [activeLanguage]: { ...(value?.[activeLanguage] || {}), [field]: fieldValue },
    });
  };

  return (
    <section className="localized-content" aria-label="Content translations">
      <div className="localized-content__heading">
        <div>
          <strong>Customer-facing translations</strong>
          <small>Optional — blank fields use the English content.</small>
        </div>
        {loading && <span className="localized-content__loading" role="status"><LoadingSpinner size="small" />Loading...</span>}
      </div>
      <div className="localized-content__tabs" role="tablist" aria-label="Translation language">
        {languages.map((language) => (
          <button
            key={language.code}
            type="button"
            role="tab"
            aria-selected={activeLanguage === language.code}
            className={activeLanguage === language.code ? "is-active" : ""}
            onClick={() => setActiveLanguage(language.code)}
          >
            {language.label}
          </button>
        ))}
      </div>
      <div className="localized-content__fields">
        {fields.map((field) => (
          <label key={field.name}>
            <span>{field.label}</span>
            {field.multiline ? (
              <textarea
                rows="3"
                value={value?.[activeLanguage]?.[field.name] || ""}
                onChange={(event) => updateField(field.name, event.target.value)}
                placeholder={field.placeholder}
              />
            ) : (
              <input
                type="text"
                value={value?.[activeLanguage]?.[field.name] || ""}
                onChange={(event) => updateField(field.name, event.target.value)}
                placeholder={field.placeholder}
              />
            )}
          </label>
        ))}
      </div>
    </section>
  );
}
